import { Product } from "../../types/Product";
import { useProductTranslations } from "../../hooks/TranslationHooks";
import { useUserProducts } from "../../hooks/ProductHooks";
import { filterProductsBySkus } from "../../utils/ProductsUtils";
import ProductGrid from "../ProductGrid";

const ProductReplacedByArea = ({
  product,
  className = ""
}: {
  product: Product;
  className?: string;
}) => {
  const tp = useProductTranslations();
  const skus = product?.replaced_by || [];
  const products = useUserProducts();
  const filteredProducts = filterProductsBySkus(products, skus);
  const cols = filteredProducts.length >= 3 ? 3 : 2;
  const layout = "list";

  return filteredProducts.length > 0 ? (
    <div className={className}>
      <h3>{tp("product_is_replaced_by")}:</h3>
      <ProductGrid
        products={filteredProducts}
        cols={cols}
        layout={layout}
        showCartButtons={false}
      />
    </div>
  ) : null;
};

export default ProductReplacedByArea;
